import { call, put, select } from "redux-saga/effects";
import api from "../../services/api";
import { Creators as ExtratoPagoActions } from "../ducks/extratoPago";
import { Creators as ErrorActions } from "../ducks/error";
import { Creators as SuccessActions } from "../ducks/success";
import { Creators as LoadingActions } from "../ducks/loading";
import { Creators as ModalSalesActions } from "../ducks/modalSales";
import { formatReal, formatPercent } from "../../helpers";
import moment from "moment";
import { Creators as AlertActions } from "../ducks/alert";

export function* getListExtratoPago({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    const { data } = yield call(
      api.post,
      `/comissions/extract-paid`,
      payload.filtro
    );
    const extratoPago = data.data;

    const totais = {
      total: formatReal(data.total),
      total_bonus: formatReal(data.total_bonus),
      total_comissions: formatReal(data.total_comissions),
      total_comissions_estornos: formatReal(data.total_comissions_estornos),
      total_discounts: formatReal(data.total_discounts),
      total_extract: formatReal(data.total_extract),
      total_receipted: formatReal(data.total_receipted),
      total_sales: data.total_sales,
      total_total_comissioned: formatReal(data.total_total_comissioned)
    };

    let extratoPagoPayload = [];

    extratoPagoPayload = extratoPago.map(extrato =>
      extrato.days.map((comission, index) => ({
        id: `${extrato.id}${index}`,
        date: moment(comission.date).format("DD/MM/YYYY"),
        sales: comission.sales,
        comissions: formatReal(comission.comissions),
        comissions_estornos: formatReal(comission.comissions_estornos),
        discounts: formatReal(comission.discounts),
        bonus: formatReal(comission.bonus),
        total_comissioned: formatReal(comission.total_comissioned),
        receipted: formatReal(comission.receipted),
        total: formatReal(comission.total)
      }))
    );

    if (extratoPago.length > 0) {
      yield put(
        ExtratoPagoActions.getListExtratoPagoSuccess(
          extratoPago,
          extratoPagoPayload,
          payload.filtro,
          totais
        )
      );
    } else {
      yield put(
        ErrorActions.openError(
          "Os filtros escolhidos não obtiveram resultados."
        )
      );
      yield put(
        ExtratoPagoActions.getListExtratoPagoSuccess(
          [],
          extratoPagoPayload,
          payload.filtro,
          totais
        )
      );
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* getExtratoPago({ payload }) {
  try {
    yield put(LoadingActions.setLoading());
    const { action } = yield select(state => state.extratoPagoStores);
    const { stores_filter: stores, users_filter: users } = yield select(state => state.filtrosExtratoPago);
    
    yield put(
      ExtratoPagoActions.getExtratoPagoSuccess(
        payload.date,
        payload.group,
        payload.group_id
      )
    );
    if (action === "DELETE") {
      const title = "Aviso de exclusão";
      const body = `Os repasses serão excluidos do sistema.`;
      yield put(AlertActions.openAlert(title, body));
    } else if (action === "DETAIL") {
      let filter = {
        date: payload.date,
        group: payload.group,
        group_id: payload.group_id,
        stores_filter: stores.map(
          store => store.split("-", 1)[0]
        ),
        users_filter: users.map(
        user => user.split("-", 1)[0]
      )
      };
      const data = yield call(
        api.post,
        `/comissions/extract-paid/detail`,filter
      );
      const pdf = data.data.pdf;
      const propostas = data.data.data.comissions;
      const estornos = data.data.data.comissions_estornos;
      const discounts = data.data.data.discounts;
      const bonus = data.data.data.bonus;
      const total_comissao = formatReal(data.data.data.total_comissions);
      const total_estorno = formatReal(
        data.data.data.total_comissions_estornos
      );
      const total_desconto = formatReal(data.data.data.total_discounts);
      const total_bonus = formatReal(data.data.data.total_bonus);
      const total_liquido = formatReal(data.data.data.total_geral);
      const date = moment(data.data.data.date).format("DD/MM/YYYY");

      let propostasPayload = [];
      let estornosPayload = [];
      let discountsPayload = [];
      let bonusPayload = [];

      const total_financed = formatReal(
        propostas.reduce((total, current) => {
          return total + current.value_financed;
        }, 0)
      );
      const total_released = formatReal(
        propostas.reduce((total, current) => {
          return total + current.value_released;
        }, 0)
      );
      const total_comissioned_total = formatReal(
        propostas.reduce((total, current) => {
          return total + current.amount;
        }, 0)
      );

      propostasPayload = propostas.map(proposta => ({
        ...proposta,
        sale_date: moment(proposta.sale_date).format("DD/MM/YYYY"),
        value_financed: formatReal(proposta.value_financed),
        value_released: formatReal(proposta.value_released),
        default_value: formatReal(proposta.default_value),
        amount: formatReal(proposta.amount),
        percent: formatPercent(proposta.percent),
        sum_values: 1
      }));

      const total_financed_estornos = formatReal(
        estornos.reduce((total, current) => {
          return total + current.value_financed;
        }, 0)
      );
      const total_released_estornos = formatReal(
        estornos.reduce((total, current) => {
          return total + current.value_released;
        }, 0)
      );
      const total_comissioned_total_estornos = formatReal(
        estornos.reduce((total, current) => {
          return total + current.amount;
        }, 0)
      );

      estornosPayload = estornos.map(estorno => ({
        ...estorno,
        sale_date: moment(estorno.sale_date).format("DD/MM/YYYY"),
        value_financed: formatReal(estorno.value_financed),
        value_released: formatReal(estorno.value_released),
        default_value: formatReal(estorno.default_value),
        amount: formatReal(estorno.amount),
        sum_values: 1
      }));

      const total_amount_discounts = formatReal(
        discounts.reduce((total, current) => {
          return total + current.amount;
        }, 0)
      );

      discountsPayload = discounts.map(estorno => ({
        ...estorno,
        date: moment(data.data.data.date).format("DD/MM/YYYY"),
        amount: formatReal(estorno.amount),
        sum_values: 1
      }));

      const total_amount_bonus = formatReal(
        bonus.reduce((total, current) => {
          return total + current.amount;
        }, 0)
      );

      bonusPayload = bonus.map(bonus => ({
        ...bonus,
        date: moment(data.data.data.date).format("DD/MM/YYYY"),
        amount: formatReal(bonus.amount),
        sum_values: 1
      }));

      const totals = {
        total_comissao,
        total_estorno,
        total_desconto,
        total_bonus,
        total_liquido,
        date
      };

      yield put(
        ExtratoPagoActions.getListPropostasSuccess(
          propostasPayload,
          total_financed,
          total_released,
          total_comissioned_total,
          estornosPayload,
          total_financed_estornos,
          total_released_estornos,
          total_comissioned_total_estornos,
          discountsPayload,
          total_amount_discounts,
          bonusPayload,
          total_amount_bonus,
          totals,
          pdf
        )
      );
      yield put(ModalSalesActions.openModalSales());
    }
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(LoadingActions.unsetLoading());
}

export function* deleteExtratoPago() {
  try {
    yield put(LoadingActions.setLoading());
    const { date, group, group_id } = yield select(
      state => state.extratoPago.item
    );
    const filtro = yield select(state => state.extratoPago.filtro);
    yield call(api.post, `/comissions/extract-paid/delete`, {
      date,
      group,
      group_id
    });
    yield put(ExtratoPagoActions.getListExtratoPago(filtro));
    yield put(SuccessActions.openSuccess("Cadastro excluído com sucesso."));
  } catch (err) {
    if (err.response.data) {
      if (err.response.data.error) {
        let message = err.response.data.error.message;
        let erros = "";
        if (
          err.response.data.error.errors &&
          err.response.data.error.errors.length > 0
        ) {
          erros = err.response.data.error.errors
            .map(err => `${err} <br/>`)
            .join("");
        }
        yield put(ErrorActions.openError(`${message}<br/>${erros}`));
      } else {
        yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
      }
    } else {
      yield put(ErrorActions.openError("Ocorreu um erro não identificado."));
    }
  }
  yield put(AlertActions.closeAlert());
  yield put(LoadingActions.unsetLoading());
}



// WEBPACK FOOTER //
// ./src/store/sagas/extratoPago.js